import { render, staticRenderFns } from "./SettingsImage.vue?vue&type=template&id=013c9e8e&scoped=true&"
import script from "./SettingsImage.vue?vue&type=script&lang=js&"
export * from "./SettingsImage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsImage.vue?vue&type=style&index=0&id=013c9e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c9e8e",
  null
  
)

export default component.exports